<template>
  <Modal v-model="printingSizeModal" :title="$t('key1001280')" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="printingSizeChange">
    <Form ref="printingSizeForm" :model="printingSizeForm" :label-width="50" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <h2 class="mb4">{{ $t('key1001281') }}</h2>
          <div class="flex align-items-center mb20">
            <span>{{ $t('key1001282') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.conventionHeight" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
            <span>{{ $t('key1001283') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.conventionWidth" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
          </div>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <h2 class="mb4">{{ $t('key1001284') }}</h2>
          <div class="flex align-items-center mb20">
            <span>{{ $t('key1001282') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.goodsHeight" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
            <span>{{ $t('key1001283') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.goodsWidth" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
          </div>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <h2 class="mb4">{{ $t('key1001285') }}</h2>
          <div class="flex align-items-center mb20">
            <span>{{ $t('key1001282') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.logisticsManifestHeight" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
            <span>{{ $t('key1001283') }}</span>
            <InputNumber :max="99999999" :min="1" v-model="printingSizeForm.logisticsManifestWidth" style="width: 100px;"></InputNumber>
            <span class="ml5 mr40">mm</span>
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="printingSizeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="printingSizeBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: "printingSizeModal",
  mixins: [Mixin],
  data() {
    return {
      printingSizeModal: false,
      printingSizeForm: {
        conventionHeight: null,
        conventionWidth: null,
        goodsHeight: null,
        goodsWidth: null,
        logisticsManifestHeight: null,
        logisticsManifestWidth: null
      },
      paramKeyColums: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initPrintingSizeData(type, obj) {
      if (Object.keys(obj).length > 0) {
        for (let key in obj) {
          this.printingSizeForm[key] = obj[key];
        }
      }
      this.paramKeyColums = type;
      this.printingSizeModal = true;
    },
    // 保存按钮
    printingSizeBtn() {
      let v = this;
      let queryList = [
        {
          businessId: v.userInfo.userId,
          paramKey: v.paramKeyColums,
          paramValue: JSON.stringify(v.printingSizeForm),
        }
      ];
      let keyList = [
        {key: 'convention', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001277')},
        {key: 'goods', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001278')},
        {key: 'logisticsManifest', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001279')}
      ];
      for (let i = 0; i < keyList.length; i++) {
        let item = keyList[i];
        if ((v.printingSizeForm[item.key + 'Height'] && !v.printingSizeForm[item.key + 'Width']) ||
          (!v.printingSizeForm[item.key + 'Height'] && v.printingSizeForm[item.key + 'Width'])) {
          v.$Message.warning(item.text);
          return false;
        }
      }
      saveErpCommonSettingParam(queryList, false).then(() => {
        v.printingSizeModal = false;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
        v.$emit('updatePrintSet', v.printingSizeForm);
      });
    },
    // 监听弹窗
    printingSizeChange(value) {
      if (!value) {
        this.printingSizeForm = {
          conventionHeight: null,
          conventionWidth: null,
          goodsHeight: null,
          goodsWidth: null,
          logisticsManifestHeight: null,
          logisticsManifestWidth: null
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>